
import { defineComponent, PropType, toRaw } from 'vue'

// components
import ButtonDropdown from '@/common/components/UI/ButtonDropdown/index.vue'
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { PVZT } from '@/core/types/pvz.types'

export default defineComponent({
    components: { ButtonDropdown, TheButton },
    props: {
        item: {
            type: Object as PropType<PVZT>,
            required: true,
        },
    },
    emits: ['update', 'add-user', 'upload'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitAddUser = () => {
            emit('add-user', toRaw(props.item))
        }

        const emitUpload = () => {
            emit('upload', { pvz_id: props.item.id, pvz_name: props.item.name })
        }

        return { emitUpdate, emitAddUser, emitUpload }
    },
})
